const STOCK_QUANTITY_RELATIVE_EPSILON = 1e-12;

/**
 * Mirrors the StockCommand server guard. The epsilon only absorbs floating
 * point noise; it is not an operational overdraw allowance.
 */
export function hasSufficientLabelStock(
  requestedQty: number,
  availableQty: number,
): boolean {
  if (
    !Number.isFinite(requestedQty)
    || !Number.isFinite(availableQty)
    || requestedQty < 0
    || availableQty < 0
  ) {
    return false;
  }
  const tolerance = Math.max(
    1,
    Math.abs(requestedQty),
    Math.abs(availableQty),
  ) * STOCK_QUANTITY_RELATIVE_EPSILON;
  return requestedQty <= availableQty + tolerance;
}
